import ArticleLayout from "@/pages/article/components/ArticleLayout";
import { articleList } from "@/mocks/articles";

const data = articleList[8];

export default function ExpertStrategiesPage() {
  return (
    <ArticleLayout
      title={data.title}
      subtitle={data.subtitle}
      category={data.category}
      readTime={data.readTime}
      heroImageUrl={data.heroImageUrl}
      introduction={data.introduction}
      sections={data.sections}
      faqs={data.faqs}
      conclusion={data.conclusion}
    />
  );
}